import React from 'react';

export default function Header({ logo, number, supportEmailId }) {
  return (
    <React.Fragment>
      <header className="header" role="banner">
        <div className="header-actions">
          <div className="header-brand">
            <a href="/" aria-label="ITMines Home">
              <img src={logo ?? null} className="onboarding-logo" alt="itmines logo" />
            </a>
          </div>
        </div>
        {(number || supportEmailId) && (
          <div className="header-actions">
            {number && (
              <>
                {/* <a href={`tel:${number}`} className="icon-btn contact-bar" aria-label="Notifications"> */}
                <span className="material-symbols-outlined" aria-label="Help and Support">
                  phone
                </span>
                <span className="card-text">{number ?? ' Mob NA'}</span>
                {/* </a> */}
              </>
            )}
            {supportEmailId && (
              <>
                {/* <a href={`mailto:${supportEmailId}`} className="icon-btn contact-bar" aria-label="Help and Support"> */}
                <span className="material-symbols-outlined" aria-label="Help and Support">
                  mail
                </span>
                <span className="card-text">{supportEmailId ?? ' Email NA'}</span>
                {/* </a> */}{' '}
              </>
            )}
          </div>
        )}
      </header>
    </React.Fragment>
  );
}
